import createClient from "openapi-fetch";
import { paths } from "../schema/api-schema";

import { QueryClient } from "@tanstack/react-query";
import { getRequestHeaders } from "utils/getRequestHeaders";
import { getEnvVar } from "ideas.env";

import { toolGet } from "./query_functions/tool/tool.get";

export const reactQueryClient = new QueryClient();

const client = createClient<paths>({
  baseUrl: getEnvVar("URL_DJANGO_v0"),
});

export const djangoQueryClient = client;

/**
 * Middleware to attach headers
 */
client.use({
  onRequest: async ({ request }) => {
    const tenantIdHeaderKey = "x-tenant-id";
    const authHeaderKey = "authorization";
    const headers = await getRequestHeaders();

    request.headers.set(authHeaderKey, headers[authHeaderKey]);
    if (tenantIdHeaderKey in headers) {
      request.headers.set(
        tenantIdHeaderKey,
        String(headers[tenantIdHeaderKey]),
      );
    } else {
      request.headers.delete(tenantIdHeaderKey);
    }
  },
});

/** API client for the IDEAS REST API */
export const DjangoClient = {
  /** Tool */
  tool: {
    get: toolGet,
  },
};
